module.exports = __webpack_public_path__ + "img/404.b39e8129.png";